import { format } from 'owa-strings';
import { formatUserTime, formatWeekDayDate, formatWeekDayShortUserDate } from 'owa-datetime';
import { OwaDate, owaDate, isEqual, subDays } from 'owa-datetime';
import { getOwaDatetimeStrings } from 'owa-strings/owa-datetime-strings';

export function formatOneDayAllDayTimeSpan(
    startDate: OwaDate,
    endDate: OwaDate,
    isShortString: boolean
): string {
    return format(
        getOwaDatetimeStrings().oneDayAllDayFormatString,
        formatDateString(startDate, isShortString)
    );
}

export function formatMultiDayAllDayTimeSpan(
    startDate: OwaDate,
    endDate: OwaDate,
    isShortString: boolean
): string {
    const end = owaDate(startDate, subDays(endDate, 1));
    return format(
        getOwaDatetimeStrings().multiDayAllDayFormatString,
        formatDateString(startDate, isShortString),
        formatDateString(end, isShortString)
    );
}

export function formatSingleDayTimeSpan(
    startDate: OwaDate,
    endDate: OwaDate,
    isShortString: boolean
): string {
    const end = owaDate(startDate, endDate);

    if (isEqual(startDate, end)) {
        return format(
            getOwaDatetimeStrings().sameDayNoDurationFormatString,
            formatDateString(startDate, isShortString),
            formatUserTime(startDate)
        );
    }

    return format(
        getOwaDatetimeStrings().sameDayFormatString,
        formatDateString(startDate, isShortString),
        formatUserTime(startDate),
        formatUserTime(end)
    );
}

export function formatSingleDayTimeSpanWithoutDate(startDate: OwaDate, endDate: OwaDate): string {
    const end = owaDate(startDate, endDate);
    return format(
        getOwaDatetimeStrings().timeSpanFormatString,
        formatUserTime(startDate),
        formatUserTime(end)
    );
}

export function formatMultiDayTimeSpan(
    startDate: OwaDate,
    endDate: OwaDate,
    isShortString: boolean
): string {
    const end = owaDate(startDate, endDate);
    return format(
        getOwaDatetimeStrings().differentDayFormatString,
        formatDateString(startDate, isShortString),
        formatUserTime(startDate),
        formatDateString(end, isShortString),
        formatUserTime(end)
    );
}

export function formatDateString(date: OwaDate, isShortString: boolean) {
    return (isShortString ? formatWeekDayShortUserDate : formatWeekDayDate)(date);
}
